import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import "./OverPanel.css";
import "./ReportInappropriate.css";
import {Button, ButtonGroup, Form, Input} from "reactstrap";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";
import TextLabel from "../../../controls/TextLabel.mjs";
import AppDislikeIcon from "../../../media/assets/AppDislikeIcon.mjs";
import AppNoDislikeIcon from "../../../media/assets/AppNoDislikeIcon.mjs";

const prefix = "ReportInappropriate";

const ReportInappropriate = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage(),
			updated: (new Date()).getTime()
		};
		this.uid = Glob.generateUid(prefix);
		this.close = this.close.bind(this);
		this.setVal = this.setVal.bind(this);
		this.ritira = this.ritira.bind(this);
		this.save = this.save.bind(this);
	}
	componentDidMount() {
		Glob.register('EscapeKeyWasPressed', this.close, this.uid);
		this.load();
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	close() {
		Glob.trigger(prefix);
	}
	ritira() {
		this.setState({saving: true}, ()=>{
			appLib.api('bacheca/ritira-segnalazione',{message: this.props.message.id}).then(() => {
				this.close();
			}).catch(() => {
				this.close();
			}).finally(() => {
				this.setState({saving: false});
			})
		});
	}
	save() {
		this.setState({saving: true}, ()=>{
			appLib.api('bacheca/set-segnalazione',{message: this.props.message.id, body: this.state.body.trim() }).then(() => {
				this.close();
			}).catch(() => {
				this.close();
			}).finally(() => {
				this.setState({saving: false});
			})
		});
	}
	load() {
		this.setState({saving: true}, ()=>{
			appLib.api('bacheca/get-segnalazione',{message: this.props.message.id}).then((res) => {
				res.updated = (new Date()).getTime();
				if ( res.body ) res.review = true;
				this.setState(res);
			}).catch(() => {
				this.close();
			}).finally(() => {
				this.setState({saving: false});
			})
		})
	}
	setVal(e) {
		const body = (e.target.value||'').replace(/\t+/g,' ');
		this.setState({
			body: body,
			valid: (body.trim().length > 16)
		});
	}
	render() {
		return (
			<div
				className={"OverPanel "+prefix+( this.state.saving ? " busy" : "" )}
				onClick={ this.close }
			>
				<div onClick={ e => e.stopPropagation() }>
					<Form
						key={ this.state.updated }
						onSubmit={ e => {
							e.preventDefault();
							if ( this.state.valid ) this.save();
						} }
					>
						<h2>
							<AppDislikeIcon />
							<span>
								{ this.state.lang === 'it' ? "Segnalazione" : "Report" }
							</span>
							<span
								className={"closer"}
								onClick={this.close}
							>
								<CloseIcon />
							</span>
						</h2>
						<h4>«<strong>{ this.props.message.subject }</strong>»</h4>
						{ this.state.lang === 'it' ? (
							this.state.review ? (
								<p>
									Hai già segnalato questo messaggio{ this.state.ignored && ', e i moderatori hanno deciso che andava bene' }.
								</p>
							) : (
								<p>
									Stai per segnalare un messaggio come inappropriato.<br />
									Accertati che lo sia davvero, prima di procedere.
								</p>
							)
						) : (
							this.state.review ? (
								<p>
									You already reported this message{ this.state.ignored && ', but moderators considered it good' }.
								</p>
							) : (
								<p>
									You are going to report an inappropriate message.<br />
									Please consider carefully if it is actually inappropriate.
								</p>
							)
						)}
						{ this.state.lang === 'it' ? (
							<p>Esponi i motivi della segnalazione:</p>
						) : (
							<p>Please comment your report:</p>
						) }
						<Input
							autoFocus={ ! this.state.review }
							name={"body"}
							type={"textarea"}
							maxLength={960}
							value={ this.state.body||''}
							onChange={ this.setVal }
						/>
						{ this.state.review && (
							<ButtonGroup
								className="btn-icon"
							>
								<Button
									color="primary"
									onClick={ this.ritira }
								>
									<b>
										{ this.state.lang === 'it' ? 'Ritiro la segnalazione' : 'I withdraw my report' }
									</b>
									<i>
										<AppNoDislikeIcon />
									</i>
								</Button>
							</ButtonGroup>
						)}
						<ButtonGroup
							className={"btn-icon"}
						>
							<Button
								color="success"
								onClick={ this.close }
								type={"reset"}
							>
								<i>
									<CloseIcon />
								</i>
								<b>
									<TextLabel value={"Cancel"} />
								</b>
							</Button>
							<Button
								color="danger"
								type="submit"
								disabled={ ! this.state.valid }
							>
								<b>
									{ this.state.review ? (
										this.state.lang==='it' ? "Aggiorna la segnalazione" : "Update the report"
									) : (
										this.state.lang==='it' ? "Invia la segnalazione" : "Send the report"
									)}
								</b>
								<i>
									<AppDislikeIcon />
								</i>
							</Button>
						</ButtonGroup>
					</Form>
				</div>
			</div>
		)
	}
}

export default ReportInappropriate;